import { render } from "./external-terms.vue?vue&type=template&id=14785a18&scoped=true"
import script from "./external-terms.vue?vue&type=script&lang=js"
export * from "./external-terms.vue?vue&type=script&lang=js"

import "./external-terms.vue?vue&type=style&index=0&id=14785a18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14785a18"]])

export default __exports__